<template>
  <section class="page-not-found">
    <div class="page-not-found-head">
      <img src="https://s3.amazonaws.com/images.growmindgrow/Robot_left_404.png" alt="">
      <div class="page-not-found-head-title">
        <h1>Opps! 404:Page not found</h1>
        <h5>We couldn’t locate the page that you were looking for</h5>
      </div>
      <img src="https://s3.amazonaws.com/images.growmindgrow/Robot_right_404.png" alt="">
    </div>

    <router-link :to="{ name: 'main-menu' }" class="page-not-found-btn">
      <button>
        Go back to the Main Menu
      </button>
    </router-link>

    <div class="page-not-found-logo">
      <img src="https://s3.amazonaws.com/images.growmindgrow/parent-site/assets/Logo.svg" alt="">
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped lang="scss">
.page-not-found {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: #BB82CF;
  font-family: "Montserrat";
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;

  &-head {
    display: flex;
    align-items: center;
    margin-bottom: 70px;

    @media (max-width: 768px) {
      flex-wrap: wrap;
      justify-content: center;
    }

    img {
      max-width: 160px;
      display: block;

      @media (max-width: 768px) {
        order: 2;
        margin: 10px 10px 0;
      }

      @media (max-width: 400px) {
        max-width: 120px;
      }
    }

    &-title {
      padding: 0 25px;
      text-align: center;
      h1 {
        font-weight: bold;
        font-size: 64px;
        line-height: 75px;
        color: #794D81;
        margin-bottom: 16px;

        @media (max-width: 768px) {
          font-size: 56px;
        }
      }
      h5 {
        font-size: 24px;
        line-height: 29px;
        color: #FFFFFF;
      }
    }
  }
  &-btn {
    padding: 18px 24px;
    background: #FFFFFF;
    border: 2px solid #000000;
    box-sizing: border-box;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 20px;
    color: #7F378B;
    margin: 0 16px 100px 16px;
    text-decoration: none;
    transition: 0.4s;

    &:hover {
      box-shadow: 3px 5px 10px -5px #000;
    }
  }
  &-logo {
    img {
      width: 240px;
    }
  }

}
</style>
